/* jgd-forms-teaser-offset: schiebt den Teaser des Shopify-Forms-App-Embeds
 * ("Spare 10 %") über unten fixierte Leisten, statt dass er sie überlappt.
 *
 * Welche Leisten zählen, bestimmt die Allow-List unten — bewusst keine
 * Vollautomatik: unten verankert sind auch Drawer, Dialoge und Backdrops,
 * die den Teaser sonst quer über den Screen schieben würden.
 *
 * Mechanik: Der Teaser liegt im offenen Shadow DOM des <shopify-forms-embed>
 * mit gehashten CSS-Modul-Klassen. Einmalig wird ein <style> in den Shadow
 * Root injiziert, das bottom an die CSS-Variable --jgd-teaser-offset bindet;
 * danach wird nur noch die Variable am Host gesetzt (vererbt in den Shadow).
 * Fail-safe: Ändert die App ihre Struktur, greift nichts und der Teaser
 * bleibt wie im Stock-Zustand auf bottom: 0.
 */
(() => {
  /* Unten fixierte Elemente, denen der Teaser ausweichen soll. */
  const SELECTORS = [
    '.sticky-add-to-cart__bar', // Horizon-Kaufleiste (PDP)
    '.pd-cookie-banner-window', // Pandectes-Consentbanner (Erstansicht)
    '#pd-cp-preferences .pd-cp-ui', // Pandectes-Einstellungs-Sheet ("Einwilligungseinstellungen verwalten")
  ];

  /* Elemente, die mehr als so viel Viewport-Höhe überdecken (z. B. die
   * Consentbar im Mobile-Vollformat), heben den Teaser nicht an — sie
   * blenden ihn aus, solange sie offen sind. Anheben wäre sinnlos (er
   * schwebte in Bildschirmmitte), und liegen lassen geht nicht: Teaser und
   * Consentbar nutzen beide maximale z-index-Werte, das später im DOM
   * stehende App-Embed gewinnt und läge sichtbar über dem Banner. */
  const MAX_COVERAGE_RATIO = 0.35;

  /* Toleranz in px, bis zu der ein Element noch als "am unteren
   * Viewport-Rand verankert" gilt (Abstand wie die Desktop-Kaufleiste). */
  const ANCHOR_TOLERANCE = 24;

  const STYLE_MARK = 'data-jgd-teaser-offset';

  let host = null;
  let lastOffset = -1;

  function findHost() {
    if (host && host.isConnected) return host;
    host = null;
    for (const el of document.querySelectorAll('shopify-forms-embed')) {
      if (el.shadowRoot && el.shadowRoot.querySelector('[class*="appEmbedBottom"]')) {
        host = el;
        break;
      }
    }
    return host;
  }

  function ensureStyle(root) {
    if (root.querySelector(`style[${STYLE_MARK}]`)) return;
    const style = document.createElement('style');
    style.setAttribute(STYLE_MARK, '');
    style.textContent = `
      [class*="appEmbedBottom"] {
        bottom: var(--jgd-teaser-offset, 0px) !important;
        visibility: var(--jgd-teaser-visibility, visible) !important;
      }
      @media (prefers-reduced-motion: no-preference) {
        [class*="appEmbedBottom"] { transition: bottom 0.3s ease; }
      }
    `;
    root.appendChild(style);
  }

  /* Höchste Überdeckung durch ein Allow-List-Element, das sichtbar, unten
   * verankert und horizontal in Konflikt mit dem Teaser ist. Maximum statt
   * Summe: die Leisten liegen alle am Viewport-Boden übereinander.
   * Übergroße Elemente (Cap) setzen stattdessen das oversized-Flag. */
  function coverage(teaserRect) {
    let max = 0;
    let oversized = false;
    for (const selector of SELECTORS) {
      for (const el of document.querySelectorAll(selector)) {
        const rect = el.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) continue;
        if (rect.bottom < window.innerHeight - ANCHOR_TOLERANCE) continue;
        if (rect.right <= teaserRect.left || rect.left >= teaserRect.right) continue;
        const height = window.innerHeight - rect.top;
        if (height <= 0) continue;
        if (getComputedStyle(el).visibility === 'hidden') continue;
        if (height > window.innerHeight * MAX_COVERAGE_RATIO) {
          oversized = true;
          continue;
        }
        max = Math.max(max, height);
      }
    }
    return { offset: Math.round(max), oversized };
  }

  function apply(embed, offset, hidden) {
    const state = hidden ? -2 : offset;
    if (state === lastOffset) return;
    lastOffset = state;
    embed.style.setProperty('--jgd-teaser-offset', `${offset}px`);
    embed.style.setProperty('--jgd-teaser-visibility', hidden ? 'hidden' : 'visible');
  }

  function update() {
    const embed = findHost();
    if (!embed) return;
    const teaser = embed.shadowRoot.querySelector('[class*="teaserContainer"]');
    if (!teaser) {
      apply(embed, 0, false);
      return;
    }
    ensureStyle(embed.shadowRoot);
    const { offset, oversized } = coverage(teaser.getBoundingClientRect());
    apply(embed, oversized ? 0 : offset, oversized);
  }

  let scheduled = false;
  function requestUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  /* Kaufleiste erscheint beim Scrollen, Consentbar verschwindet per Klick,
   * das Embed mountet verzögert — Events plus grobes Sicherheitsintervall. */
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  setInterval(requestUpdate, 1500);
  requestUpdate();
})();
